module.exports = __webpack_public_path__ + "static/backdrop-6b235512999e7b33b9ec527d514f6f83.jpg";